import { render, staticRenderFns } from "./tabsProblem.vue?vue&type=template&id=72793056&scoped=true"
import script from "./tabsProblem.vue?vue&type=script&lang=js"
export * from "./tabsProblem.vue?vue&type=script&lang=js"
import style0 from "./tabsProblem.vue?vue&type=style&index=0&id=72793056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72793056",
  null
  
)

export default component.exports